  export function smartenQuotes(input: string): string {
    if (!input) return '';

    return input
      .replace(/(\w)?'(\w)?/g, '$1’$2')
      .replace(/(^|[\s\[{(])"/g, '$1“')
      .replace(/([^\s\[{(])"/g, '$1”')
  }